import { createAsyncThunk } from "@reduxjs/toolkit"
import { getConfigurationApi, getExportDataApi, searchBusinessApi } from "../apis"
import { ISearchBusinessData } from "../apis/IApisInterface"

export const searchBusinessAction = createAsyncThunk("search/business", async ( data: ISearchBusinessData, { rejectWithValue }) => {
    try {
        const response = await searchBusinessApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not search business" })
    }
})

export const getExportDataAction = createAsyncThunk("export/business", async ( _, { rejectWithValue }) => {
    try {
        const response = await getExportDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not export business" })
    }
})

export const getConfigurationAction = createAsyncThunk("get/configuration", async ( _, { rejectWithValue }) => {
    try {
        const response = await getConfigurationApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get configuration" })
    }
})
export const getAdminConfigurationAction = createAsyncThunk("get/Adminconfiguration", async ( _, { rejectWithValue }) => {
    try {
        const response = await getConfigurationApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get configuration" })
    }
})
